import {
  FontSizes,
  WINDOW_HEIGHT,
  WINDOW_WIDTH,
  hs,
  isPhone,
  vs,
} from '../../Utils/Dimensions';

import CCColors from '../../Utils/CCColors';
import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  container: {
    height: WINDOW_HEIGHT,
    width: WINDOW_WIDTH,
    flex: 1,
    // flexDirection: 'row',
    // justifyContent: 'space-between',
    // alignItems: 'center',
  },
  logoutButton: {
    width: 'fit-content',
    position: 'absolute',
    top: 0,
    right: 20,
  },
  logo: {
    width: isPhone ? vs(200) : vs(162),
    height: 32,
    marginVertical: 20,
    marginHorizontal: 'auto',
  },
  signInTypo: {
    textAlign: 'right',
    left: '50%',
    top: 48,
    color: CCColors?.Primary?.Default,
    position: 'absolute',
  },
  labelText: {
    // width: '100%',
    height: '100%',
    // justifyContent: 'center',
    // flex: 0.4,
  },
  rightlabelText: {
    paddingLeft: isPhone ? vs(10) : vs(20),
    flex: 1,
    // height: '30%',
    // marginTop: '6%',
  },
  buttonStyles: {
    fontSize: FontSizes[9],
    paddingVertical: vs(3),
    color: CCColors.TextColor.Primary,
  },
  buttonWrapper: {
    backgroundColor: '#FACF47',
    borderColor: '#262322',
    borderRadius: 8,
    // height: vs(48),

    ...(isPhone
      ? {width: '98%'}
      : {
          width: vs(240),
        }),
  },
  buttonWrapper2: {
    backgroundColor: '#FAF6EB',
    borderColor: '#262322',
    ...(isPhone && {width: '70%', margin: 'auto'}),
  },
  textBoxes: {
    height: 48,
    width: 320,
    borderRadius: 8,
    borderColor: CCColors.TextBoxes.Borders,
    borderWidth: 1,
  },
  levelModalCustom: {
    borderRadius: 12,
    backgroundColor: 'white',
    zIndex: 5,
    overflowY: 'hidden',
    width: '70%',

    margin: 'auto',
    padding: 0,
  },
  cardContainer: {
    flexDirection: 'row',
    gap: vs(12),
    // flex: 1,
    backgroundColor: 'pink',
    width: '10%',
  },
  cardContainerMobile: {
    flexDirection: 'column',
    alignItems: 'center',
    gap: vs(16),
    width: '100%',
  },
  card: {
    borderWidth: 1,
    borderColor: '#22222233',
    borderRadius: vs(8),
    alignItems: 'center',
  },
  cardMobile: {
    width: '100%', // Ensure full width on mobile
    paddingLeft: vs(12),
    paddingTop: vs(12),
    borderWidth: 1,
    borderColor: '#22222233',
    borderRadius: vs(8),
    alignItems: 'center',
  },
  cardContent: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },
  textContainer: {
    flex: 1,
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    gap: vs(6),
  },
  textContainerMobile: {
    alignItems: 'center',
    textAlign: 'center',
  },
  avatar: {
    width: vs(84),
    height: vs(80),
    resizeMode: 'contain',
  },
  cardTitle: {
    fontSize: FontSizes[16],
    fontWeight: '600',
    lineHeight: 24,
    color: CCColors?.TextColor?.Primary,
    textAlign: 'left',
  },
  cardSubtitle: {
    fontSize: FontSizes[14],
    fontWeight: '400',
    lineHeight: 20,
    color: CCColors?.TextColor?.LightGrey,
    textAlign: 'left',
  },
  checkmark: {
    textDecorationColor: CCColors?.TextColor?.Primary,
    position: 'absolute',
    top: vs(-8),
    right: vs(6),
  },
  selectedCard: {
    borderColor: CCColors?.Primary?.Brown,
    borderWidth: 2,
  },
  inputStyling: {
    padding: vs(14),
    borderColor: CCColors.OnboardingGrey,
    borderWidth: 1,
    borderRadius: 8,
    width: '100%',
    color: CCColors.TextColor.GreyText,
    paddingRight: hs(18),
    outline: 'none',
  },
});
